/**
 * Initialize blocks and set conditions according to the device
 *
 */
export function initShareBtn() {
    [...document.querySelectorAll('.c-share-btn:not(.-initialiazed)')].forEach((item) => handleShareBtn(item));
}

/**
 * Handle handleShareBtn
 * @param {HTMLElement} group
 */
function handleShareBtn(group) {
    group.classList.add('-initialiazed');

    let share_btn = document.querySelector('.c-share-btn');
    let share_label = share_btn.querySelector('.c-share-btn__inner-label');
    // let share_icons = share_btn.querySelector('.c-share-btn__inner-icons');

    // click event to show share icons
    share_label.addEventListener('click', function () {
        share_label.parentElement.parentElement.classList.toggle('-is-active');
        // copy URL and create feedback div that will be removed after 3 second with displays that the urls was copied
        handleShareCopyToClipboard(window.location.href).then(r => {
            let feedback = document.createElement('div');
            feedback.style =
                'position: absolute;' +
                'left: 50%;' +
                'top: -1rem;' +
                'transform: translate(-50%, 0);' +
                'padding: 0.5rem 1rem;' +
                'background-color: #000;' +
                'color: #fff;' +
                'font-size: 0.75rem;';
            feedback.classList.add('c-share-btn__feedback');
            feedback.innerHTML = 'copied to clipboard';
            share_label.appendChild(feedback);

            setTimeout(() => {
                feedback.remove();
                share_label.parentElement.parentElement.classList.toggle('-is-active');
            }, 2000);
        });
    });

    // click event to hide share icons
    // share_icons.addEventListener('click', function () {
    //     share_icons.parentElement.parentElement.classList.remove('-is-active');
    // });
}

async function handleShareCopyToClipboard(textToCopy) {
    // Navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(textToCopy);
    } else {
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;

        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";

        document.body.prepend(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
        } catch (error) {
            console.error(error);
        } finally {
            textArea.remove();
        }
    }
}
